export const QuarantineExcelHeader = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "CUSTOMER NAME",
    key: "CUSTOMER NAME",
  },
  {
    header: "CUSTOMER CODE",
    key: "CUSTOMER CODE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "AWB NO",
    key: "AWB NO",
  },
  {
    header: "LOCATION",
    key: "LOCATION",
  },
  {
    header: "UNPROPER PACKING",
    key: "UNPROPER PACKING",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "ACCOMPLISH DATE",
    key: "ACCOMPLISH DATE",
  },
  {
    header: "QUARANTINE REMARK",
    key: "QUARANTINE REMARK",
  },
];

export const QuarantineExcelName = "Quarantine List";
